import Layout from '@layout/Index'

export const taskPackageHome = [
  {
    path: '/task-package-home',
    component: Layout,

    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "TaskPackageHomeTable" */ './pages/TaskPackageHomeTable.vue'),
        name: '首页任务包设置',
        meta: {
          title: '首页任务包设置',
        },
      },
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "TaskPackageHomeForm" */ './pages/TaskPackageHomeForm.vue'),
        name: '新增任务包',
        meta: {
          title: '新增任务包',
        },
      },
      {
        path: 'update/:packageId',
        component: () => import(/* webpackChunkName: "TaskPackageHomeForm" */ './pages/TaskPackageHomeForm.vue'),
        name: '修改任务包',
        meta: {
          title: '修改任务包',
        },
      },
      {
        path: 'preview',
        component: () => import(/* webpackChunkName: "TaskPackagePreview" */ './pages/TaskPackagePreview.vue'),
        name: '任务包预览',
        meta: {
          title: '任务包预览',
        },
      }
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/task-package-home/task-package-home.route.js